module.exports = __webpack_public_path__ + "img/shijiazhuangjidi2.a28b39aa.png";